<script>
export default {
	methods: {
		getNMIChart(data) {
			const amountSpent = data.totalExpenses;
			const amountLeft = this.netMonthlyIncome - data.totalExpenses;
			return {
				title: this.$t('NMI'),
				fullAmount: this.netMonthlyIncome,
				dataset: [
					{
						title: this.$t('amountSpent'),
						value: amountSpent,
						ariaLabel: this.$t('amountSpentChart', { amountSpent })
					},
					{
						title: this.$t('leftToSpent'),
						value: amountLeft,
						ariaLabel: this.$t('amountLeftChart', { amountLeft })
					}
				],
				ariaLabel: this.$t('NMIChart', {
					NMI: this.netMonthlyIncome
				})
			};
		},
		getSavingsChart(savings, config) {
			const totalSavings = this.getTotalSavingsAmount(savings);

			return {
				title: this.$t('savings'),
				fullAmount: totalSavings,
				dataset: savings.map(item => {
					let savingName = null;
					if (item.name) {
						savingName = item.name;
					} else {
						savingName = item.cmsGoal
							? item.cmsGoal.name
							: this.$t('generalSavings');
					}
					return {
						title: savingName,
						value: item[config.amountProp],
						ariaLabel: this.$t('savingChart', {
							goal: savingName,
							goalAmount: item[config.amountProp]
						})
					};
				}),
				ariaLabel: config.isPerMonth
					? this.$t('monthlySavingsChart', {
							totalSavings
					  })
					: this.$t('totalSavingsChart', {
							totalSavings
					  })
			};
		}
	}
};
</script>
